import { CDN_FRONT, PUBLIC_PATH } from 'shared/config'

const getValidUrl = (url: string) => {
  let newUrl = url
  if (PUBLIC_PATH && url.startsWith(PUBLIC_PATH)) {
    newUrl = newUrl.replace(PUBLIC_PATH, '')
  }
  if (newUrl.startsWith('/')) {
    newUrl = newUrl.replace('/', '')
  }

  return newUrl
}

export const getCDNAssetURL = (url: string) => {
  const newUrl = getValidUrl(url)
  const isCdnFront = CDN_FRONT && newUrl.includes(CDN_FRONT)

  if (isCdnFront) return newUrl

  return CDN_FRONT ? `https://${CDN_FRONT}/ui/v2/${newUrl}` : url
}
